module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"weather":"Погода"},"en":{"weather":"Weather"}}')
  delete Component.options._Ctor
}
